import {EffectPointerPlayer} from "../../../../Server/DB/@Shared/EffectPointerPlayer.js";
import {AlarmSequence} from "../../../../Server/DB/engineConfigs/@EngineConfig/Alarms/@AlarmConfig.js";
import {EngineConfig_ShakeAlarm} from "../../../../Server/DB/engineConfigs/@EngineConfig/Alarms/@EC_BasicAlarms.js";
import {LiveSession} from "../../../LiveSession.js";
import {AlarmComp} from "./@AlarmComp.js";

export class ShakeAlarmComp extends AlarmComp<EngineConfig_ShakeAlarm> {
	constructor(session: LiveSession, sequence: AlarmSequence, config: EngineConfig_ShakeAlarm) {
		super(session, sequence, config);
	}

	promptPlayer = new EffectPointerPlayer();

	override OnStart() {
		this.promptPlayer.effectPointer = this.c.effectPointer;
		this.promptPlayer.OnStart();
	}
	
	override async PlayAlarmEffect() {
		await this.promptPlayer.Play(this.intensity);
	}
	override UpdatePrompt_ForReducedIntensity() {
		this.promptPlayer.NotifyReducedIntensity(this.intensity);
	}
	override StopAlarm(...args: Parameters<AlarmComp<any>["StopAlarm"]>) {
		this.promptPlayer.Stop();
		return super.StopAlarm(...args);
	}
}